export default {
  namespaced: true,
  state: {
    currentTime: 0,
  },
  getters: {
    currentTime: state => state.currentTime,
  },
  mutations: {
    setCurrentTime(state, time) {
      state.currentTime = time;
    },
  },
  actions: {
    updateCurrentTime: ({ commit }, time) => {
      commit('setCurrentTime', time);
    },
  },
};
